import React, { useContext, useEffect } from 'react';
import Select from 'react-select';
import { Text, View } from '@/styles/reactnative';
import { useTranslation } from 'react-i18next';
import { getSetting, useSetting } from '@app/hooks/user/mysetting';
import { SETTING_TYPE_SYSTEM } from '@app/constants/SETTING';
import { useFetcherPublic } from '@app/hooks/fetcher';
import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';
import { MobileCalVW, useIsMobile } from '@utils/CalVW.tsx';
import { getCustomStyles } from '../customStyle';
import { ThemeContext } from '@/theme/ThemeProvider';

const CurrencyBox = () => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const isMobile = useIsMobile();

  const { data: setting, updateSetting } = useSetting(SETTING_TYPE_SYSTEM);
  const currency = getSetting(setting, 'CURRENCY', 'USD');

  const { data: result } = useFetcherPublic('/system/currency');
  const currencyOptions = result?.result?.result?.map((item: any) => ({
    value: item.code,
    label: item.name,
  }));

  const customStyles = getCustomStyles(theme);

  return (
    <View
      style={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '20px 10px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
      }}
    >
      <Contents
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          marginBottom: isMobile ? 20 : undefined,
        }}
      >
        <Text
          size={20}
          style={{ fontWeight: '500', marginBottom: isMobile ? 10 : undefined }}
        >
          {t('currency')}
        </Text>

        <Text
          size={18}
          style={{ fontWeight: '400', color: '#007AFF', lineHeight: 1 }}
        >
          {t('equivalentCurrency')}
        </Text>
      </Contents>

      <View style={{ width: isMobile ? '100%' : '40%' }}>
        <Select
          defaultValue={currencyOptions?.find(
            (item: any) => item.value === currency
          )}
          options={currencyOptions}
          styles={customStyles}
          onChange={({ value }: any) => {
            console.log(value);
            updateSetting('CURRENCY', value);
          }}
        />
      </View>
    </View>
  );
};

export default React.memo(CurrencyBox);

const Contents = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;

  @media ${media.mobile} {
    margin-top: ${MobileCalVW(20)};
    gap: ${MobileCalVW(12)};
  }
`;
